import * as FS from "fs-jetpack";
import * as fs from "fs-jetpack";
import * as Path from "path";
import * as toml from "@iarna/toml";
// import { mergeTypes } from "../helpers/schema";
// const { loadFiles } = require("@graphql-tools/load-files");

const { GraphQLFileLoader } = require("@graphql-tools/graphql-file-loader");
import { loadSchemaSync, loadSchema } from "@graphql-tools/load";
// import { loadFiles } from "@graphql-tools/load-files";

export async function loadString(p: string) {
  try {
    return await fs.readAsync(p, "utf8");
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export function loadStringSync(p: string) {
  return fs.read(p, "utf8");
}

export async function writeString(p: string, file: string) {
  try {
    return await fs.writeAsync(p, file);
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export function writeStringSync(p: string) {
  return fs.read(p, "utf8");
}

export function loadTomlSync(p: string) {
  return toml.parse(loadStringSync(p));
}

export async function loadToml(p: string) {
  return toml.parse(await loadString(p));
}

export function writeTomlSync(p: string, file: toml.JsonMap) {
  return fs.write(p, toml.stringify(file));
}

export async function writeToml(p: string, file: toml.JsonMap) {
  return fs.writeAsync(p, toml.stringify(file));
}

export function loadJsonSync(p: string) {
  try {
    return fs.read(p, "json");
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export async function loadJson(p: string) {
  try {
    return await fs.readAsync(p, "json");
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export function writeJsonSync(p: string, file: object) {
  try {
    return fs.write(p, file);
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export async function writeJson(p: string, file: object) {
  try {
    return await fs.writeAsync(p, file);
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export function loadGraphqlSchemaSync(p: string) {
  try {
    const schema = loadSchemaSync(p, {
      loaders: [new GraphQLFileLoader()],
    });
    return schema;
  } catch (e) {
    console.log(e);
  }
}

export async function loadGraphqlSchema(p: string) {
  try {
    const schema = await loadSchema(p, {
      loaders: [new GraphQLFileLoader()],
    });
    return schema;
  } catch (e) {
    console.log(e);
  }
}

export function writeGraphqlSync(p: string, file: string) {}

export function writeGraphql(p: string, file: string) {}

export function lsDirSync(p: string) {}

export function lsDir(p: string) {}

export function removeWriteSync(filePath: string, fileContent: string): void {
  FS.remove(filePath);
  FS.write(filePath, fileContent);
}

export async function removeWrite(
  filePath: string,
  fileContent: string
): Promise<void> {
  await FS.removeAsync(filePath);
  await FS.writeAsync(filePath, fileContent);
}

/**
 * Write file contents but first delete the file off disk if present. This is a
 * useful function when the effect of file delete is needed to trigger some file
 * watch/refresh mechanism, such as is the case with VSCode TS declaration files
 * inside `@types/` packages.
 *
 * For more details that motivated this utility refer to the originating issue
 * https://github.com/prisma-labs/nexus-prisma/issues/453.
 */
export function hardWriteFileSync(filePath: string, data: string) {
  FS.remove(Path.dirname(filePath));
  FS.write(filePath, data);
}

export async function hardWriteFile(filePath: string, data: string) {
  await FS.removeAsync(Path.dirname(filePath));
  await FS.writeAsync(filePath, data);
}
